import React, { useEffect, useState } from "react";
import { admin } from "../../lib/api";

const TABS = [
  ["finding_blocks", "Finding Blocks"],
  ["opportunity_catalog", "Opportunity Catalog"],
  ["exposure_flags", "Exposure Flags"],
  ["regulator_lookup", "Regulator Lookup"],
  ["regulator_registry", "Regulator Registry"],
];

export default function ContentAdmin() {
  const [active, setActive] = useState("finding_blocks");
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const res = await admin.content(active);
        setRows(res.rows);
      } finally { setLoading(false); }
    })();
  }, [active]);

  return (
    <div data-testid="content-admin-page">
      <div className="cw-eyebrow">Content Administration</div>
      <h1 className="cw-display-l" style={{ marginTop: 8 }}>Blocks, catalog, flags.</h1>
      <p className="cw-body" style={{ marginTop: 8, color: "rgba(22,30,27,0.72)" }}>
        Read-only view of the content tables the scoring engine and assembler rely on. Editable
        administration is deferred to a later phase (a light CRUD is safe to build later on this same shape).
      </p>

      <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginTop: 24 }}>
        {TABS.map(([id, label]) => (
          <button
            key={id}
            className={`cw-btn ${active === id ? "light-primary" : "cw-btn-text"}`}
            style={{ height: 40, padding: "0 16px" }}
            onClick={() => setActive(id)}
            data-testid={`content-tab-${id}`}
          >{label}</button>
        ))}
      </div>

      {loading && <p style={{ marginTop: 24 }} data-testid="content-loading">Loading…</p>}
      {!loading && (
        <div className="cw-card" style={{ marginTop: 24, overflowX: "auto", padding: 0 }}>
          <table className="cw-table" data-testid={`content-table-${active}`}>
            <thead>
              <tr>{rows[0] && Object.keys(rows[0]).slice(0, 8).map((k) => <th key={k}>{k}</th>)}</tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id || r.name_or_alias || JSON.stringify(r).slice(0, 40)}>
                  {Object.entries(r).slice(0, 8).map(([k, v]) => (
                    <td key={k} style={{ maxWidth: 380, overflow: "hidden", textOverflow: "ellipsis" }}>
                      {typeof v === "object" ? JSON.stringify(v) : String(v)}
                    </td>
                  ))}
                </tr>
              ))}
              {rows.length === 0 && (
                <tr><td colSpan={8} style={{ textAlign: "center", color: "rgba(22,30,27,0.72)" }}>No rows.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
